// import login from "@/api/login";
// import { v1 as uuidv4 } from "uuid";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

const user = {
  state: {
    token: localStorage.getItem("token") || "",
    userSignInType: "",
    role: "",
    email: "",
    id: "",
    userId: "",
    userFullName: "",
    picture: "",
    registerUsing: "",
    userProfile: {
      userBasicDetails: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        picture: "",
        username: "",
        password: ""
      },
      companyDetails: {
        name: "",
        address: {
          location: "",
          line1: "",
          line2: "",
          city: "",
          state: "",
          postalCode: ""
        }
      },
      providerDetails: {
        provider: "",
        providerKey: ""
      }
    },
    auth: {
      accessToken: "",
      refreshToken: "",
      isRefreshingTokens: "",
      tokenValidity: ""
    },
    userIdentifier: "",
    companyID: "",
    selectedMenuTitle: "",
    eventTitle: "",
    eventLocation: "",
    selectedEventHolidayCalendarOptIn: ""
  },
  getters: {
    isLoggedIn: state => !!state.token,
    eventTitle: state => state.eventTitle,
    eventLocation: state => state.eventLocation,
    roles: state => state.role,
    token: state => state.token,
    userId: state => state.userId,
    user: state => state.email,
    name: state => state.userFullName
  },

  mutations: {
    setToken(state, updatedValue) {
      state.token = updatedValue;
    },
    setRole(state, updatedValue) {
      state.role = updatedValue;
    },
    setEmail(state, updatedValue) {
      state.email = updatedValue;
    },
    setId(state, updatedValue) {
      state.id = updatedValue;
    },
    setUserId(state, updatedValue) {
      state.userId = updatedValue;
    },
    setUserFullName(state, updatedValue) {
      state.userFullName = updatedValue;
    },
    setRegisterusing(state, updatedValue) {
      state.registerUsing = updatedValue;
    },
    setPicture(state, updatedValue) {
      state.picture = updatedValue;
    },
    SET_EVENT: (state, newValue) => {
      state.eventTitle = newValue;
    },
    SET_LOCATION: (state, newValue) => {
      state.eventLocation = newValue;
    },
    updateUserProfile(state, updatedValue) {
      state.userProfile = updatedValue;
    },
    updateUserSignInType(state, updatedValue) {
      state.userSignInType = updatedValue;
    },
    updateSelectedMenuTitle(state, updatedValue) {
      state.selectedMenuTitle = updatedValue;
    },
    updateselectedEventHolidayCalendarOptIn(state, updatedValue) {
      state.selectedEventHolidayCalendarOptIn = updatedValue;
    },
    updateAccessToken(state, updatedValue) {
      state.auth.accessToken = updatedValue;
    },
    updateRefreshToken(state, updatedValue) {
      state.auth.refreshToken = updatedValue;
    },
    updateUserIdentifier(state, updatedValue) {
      state.userIdentifier = updatedValue;
    },
    updateCompanyID(state, updatedValue) {
      state.companyID = updatedValue;
    },
    updateisTokenRefreshing(state, updatedValue) {
      state.auth.isRefreshingTokens = updatedValue;
    },
    updateTokenValidity(state, updatedValue) {
      state.auth.tokenValidity = updatedValue;
    },
    logout(state) {
      state.token = "";
      state.role = "";
      state.email = "";
      state.id = "";
      state.userId = "";
      state.userFullName = "";
      state.picture = "";
      state.registerUsing = "";
      state.userProfile = {
        userBasicDetails: {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          picture: "",
          username: "",
          password: ""
        },
        companyDetails: {
          name: "",
          address: {
            location: "",
            line1: "",
            line2: "",
            city: "",
            state: "",
            postalCode: ""
          }
        },
        providerDetails: {
          provider: "",
          providerKey: ""
        }
      };
      state.auth = {
        accessToken: "",
        refreshToken: "",
        isRefreshingTokens: "",
        tokenValidity: ""
      };
      state.userSignInType = "";
      state.userIdentifier = "";
      state.companyID = "";
      state.selectedMenuTitle = "";
      state.selectedEventHolidayCalendarOptIn = "";
    }
    // SET_USER_INFO: (state, payload) => {
    //   if (payload.logout) {
    //     state.token = "";
    //     (state.refreshToken = ""),
    //       (state.tokenExpiryTime = ""),
    //       (state.roles = "");
    //     state.user = "";
    //     state.name = "";
    //     state.userId = "";
    //     state.customerId = "";
    //     state.referenceId = "";
    //     state.reportvalue = "";
    //     state.auditFinanceCustomer = "";
    //     state.auditFinanceFromDate = "";
    //     state.auditFinanceToDate = "";
    //     state.FinanceCustomerName = "";
    //     state.ToolsComName = "";
    //     state.ToolsCustomerId = "";
    //     state.ToolsapiToken = "";
    //     (state.AppSheetToolsComName = ""),
    //       (state.AppSheetToolsCustomerId = ""),
    //       (state.AppSheetToolsapiToken = ""),
    //       (state.reportId = ""),
    //       (state.companyName = "");
    //       state.supportTicketsReferenceId = "";
    //   } else {
    //     state.token = payload.token || state.token;
    //     // state.refreshToken = payload.refreshToken || state.refreshToken;
    //     // state.tokenExpiryTime = payload.tokenExpiryTime || state.tokenExpiryTime;
    //     state.roles = payload.userRole || state.userRole;
    //     state.user = payload.username || state.username;
    //     state.name = payload.flName || state.flName;
    //     state.userId = payload.userId || state.userId;
    //     state.customerId = payload.customerId || state.customerId;
    //     state.referenceId = payload.referenceId || state.referenceId;
    //     state.reportvalue = payload.reportvalue || state.reportvalue;
    //     state.auditFinanceCustomer =
    //       payload.auditFinanceCustomer || state.auditFinanceCustomer;
    //     state.auditFinanceFromDate =
    //       payload.auditFinanceFromDate || state.auditFinanceFromDate;
    //     state.auditFinanceToDate =
    //       payload.auditFinanceToDate || state.auditFinanceToDate;
    //     state.FinanceCustomerName =
    //       payload.FinanceCustomerName || state.FinanceCustomerName;
    //     state.ToolsComName = payload.ToolsComName || state.ToolsComName;
    //     state.ToolsCustomerId =
    //       payload.ToolsCustomerId || state.ToolsCustomerId;
    //     state.ToolsapiToken = payload.ToolsapiToken || state.ToolsapiToken;
    //     (state.AppSheetToolsComName =
    //       payload.AppSheetToolsComName || state.AppSheetToolsComName),
    //       (state.AppSheetToolsCustomerId =
    //         payload.AppSheetToolsCustomerId || state.AppSheetToolsCustomerId),
    //       (state.AppSheetToolsapiToken =
    //         payload.AppSheetToolsapiToken || state.AppSheetToolsapiToken),
    //       (state.reportId = payload.reportId || state.reportId),
    //       (state.companyName = payload.companyName || state.companyName);
    //       state.supportTicketsReferenceId = payload.supportTicketsReferenceId || state.supportTicketsReferenceId;
    //   }
    // },
  },

  actions: {
    // // Login user dispatch
    // LoginByEmail: async ({ commit }, payload) => {
    //   try {
    //     const response = await login.loginByEmail(
    //       payload.username.trim(),
    //       payload.password
    //     );
    //     if (response.isSuccess) {
    //       await commit("SET_ACCESS_TOKEN", response.tokenResponse.access_token);
    //       await commit(
    //         "SET_REFRESH_TOKEN",
    //         response.tokenResponse.refresh_token
    //       );
    //       await commit(
    //         "SET_TOKEN_EXPIRY_TIME",
    //         response.tokenResponse.expires_at
    //       );

    //       if (JSON.stringify(response.userInformation) !== "{}") {
    //         // response.userInformation.access_token = uuidv4();
    //         response.userInformation.flName =
    //           response.userInformation.firstName +
    //           " " +
    //           response.userInformation.lastName;
    //         await commit("SET_USER_INFO", response.userInformation);

    //         ////set default customer values to store
    //         await commit("SET_REPORTID", response.defaultCompanyId);
    //         await commit("SET_COMPANYNAME", response.defaultCompanyName);
    //         await commit("REFERENCE_ID", response.defaultCompanyId);
    //         await commit("SET_SUPPORT_REF_ID", response.userInformation.supportReferenceId);
    //         // await commit("SET_REPORTID", null);
    //         // await commit("SET_COMPANYNAME", null);
    //         // await commit("REFERENCE_ID", null);

    //         return true;
    //       } else {
    //         return false;
    //       }
    //     }
    //   } catch (err) {
    //     console.warn("[vuex.user] LoginByEmail", err);
    //   }
    // },
    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");
        this.state.token = null;
        this.state.role = "";
        this.state.email = "";
        this.state.id = "";
        this.state.picture = "";
        this.state.registerUsing = "";
        //Remove all secure local storage keys created
        ls.removeAll();
        resolve();
      });
    },
    setEvent: ({ commit, state }, newValue) => {
      commit("SET_EVENT", newValue);
      return state.message;
    },
    setLocation: ({ commit, state }, newValue) => {
      commit("SET_LOCATION", newValue);
      return state.message;
    }

    // LogOut: async ({ commit }) => {
    //   try {
    //     await commit("SET_USER_INFO", { logout: true });
    //   } catch (err) {
    //     console.warn("[vuex.user] LogOut", err);
    //   }
    // }
  }
};

export default user;
